import { makeRequestConfig } from './make-request-config';
export var loggerRequest = function (_a) {
    var params = _a.params, Requestor = _a.Requestor, endpoint = _a.endpoint;
    return new Requestor().makeRequest(makeRequestConfig({ endpoint: endpoint, params: params }));
};
